var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLnkdin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.521 23.0051V17.1401C20.521 15.9361 19.683 14.7341 18.309 14.7341C16.937 14.7341 16.33 15.9361 16.33 17.1701V23.0051H12.851V12.2371H16.309V13.7111C17.272 12.4471 18.165 11.8761 19.683 11.8761C21.203 11.8761 24.001 12.6581 24.001 16.8981V23.0051H20.521ZM9.046 10.7851C7.915 10.7851 7 9.93714 7 8.89014C7 7.84414 7.915 6.99414 9.046 6.99414C10.176 6.99414 11.092 7.84414 11.092 8.89014C11.092 9.93714 10.176 10.7851 9.046 10.7851ZM10.771 23.0051H7.292V12.2371H10.771V23.0051Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnkdin);
export default __webpack_public_path__ + "static/media/lnkdin.657044fa9501571701c05ddd324ef99d.svg";
export { ForwardRef as ReactComponent };